module.exports = __webpack_public_path__ + "img/line-right.bd01e6fe.png";